// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-company-requisites-index-wrapper-vmspa{display:grid;grid-gap:24px}.pages-company-requisites-index-pageWrapper-bapdi{padding-bottom:48px}.pages-company-requisites-index-pageWrapper-bapdi.pages-company-requisites-index-mobile-byizn{padding-top:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "pages-company-requisites-index-wrapper-vmspa",
	"pageWrapper": "pages-company-requisites-index-pageWrapper-bapdi",
	"mobile": "pages-company-requisites-index-mobile-byizn"
};
module.exports = ___CSS_LOADER_EXPORT___;
